import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '~/components/isolated/Carousel';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';

import { cartStore, userStore } from '~/stores';

import type { DeliverySlotItemProps } from './interfaces';
import styles from './ModalSlotsChangedEvent.module.scss';
import { useDeliverySlotDates } from './useDeliverySlotDates';

const carouselOpts = {
  align: 'start' as const,
  slidesToScroll: 1,
  containScroll: 'trimSnaps' as const,
};

const DeliverySlotItem = ({ deliveryDifference }: DeliverySlotItemProps) => {
  const { handleClickProduct } = useCategoryAnalytics();

  const { selectedDay, previousSelectedDate } = useDeliverySlotDates({
    slot: deliveryDifference.slot,
    previousDeliverySlot: deliveryDifference.previousDeliverySlot,
    expressDeliveryLabelClassName: styles.expressDeliveryLabel,
  });

  const deliveryItems = cartStore.selectedCartItems.filter(({ sku }) =>
    deliveryDifference.itemsIds.includes(sku),
  );

  return (
    <li className={styles.slotItem}>
      <div className={styles.slotDate}>
        <span className={styles.previousDate}>{previousSelectedDate}</span>
        <div className={styles.actualDate}>{selectedDay}</div>
      </div>
      <ul className="slot-list__slot-images">
        <Carousel opts={carouselOpts} dir={userStore.dir} key={userStore.dir}>
          <CarouselContent>
            {deliveryItems.map((offer) => (
              <CarouselItem className={styles.slide} key={offer.images[0]}>
                <Link
                  onClick={handleClickProduct(offer)}
                  to={`/p/${offer.productId}?sku=${offer.sku}`}
                  state={{ offerSku: offer.sku }}
                >
                  <div className="slot-list__slot-images-item">
                    <img alt={offer.name} src={offer.images[0]} />
                  </div>
                </Link>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </ul>
    </li>
  );
};

export default observer(DeliverySlotItem);
